import {getAuthUrl} from '../api.config';
import axiosInstance from '../non-protected';

export const AuthService = {
  async logout() {
    await axiosInstance.post(getAuthUrl('/logout'));
  },

  async getAuthUrl() {
    return await axiosInstance.get(getAuthUrl('/url'));
  },
};
